import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCareerLevels() {
  const [careerLevels, setCareerLevels] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.career_levels.index)
      .then((response) => {
        setCareerLevels(response.data.data);
      });
  }, []);

  return careerLevels;
}
